/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type CustomerUpdateType =
  typeof CustomerUpdateType[keyof typeof CustomerUpdateType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomerUpdateType = {
  UPDATING: 'UPDATING',
  CLOSING: 'CLOSING',
} as const;
